// extracted by mini-css-extract-plugin
export var currentStep = "_gg-2";
export var nodeCard = "_gg-0";
export var pathHighlighted = "_gg-1";